<script lang="ts">
	import BuyCampfireLink from "@components/BuyCampfireLink.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Media from "@components/common/Media.svelte";
	import Portal from "@components/common/Portal.svelte";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
	import type { DOMAttributes } from "svelte/elements";
	import cross from "@core/assets/icons/close.svg?raw";
	import flame from "@core/assets/icons/flame.svg";
	import type { MenuItem } from "@core/schema/MenuItem.js";
	import { getHomepagePath } from "@core/schema/paths/getHomepagePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	interface MenuProps extends DOMAttributes<HTMLElement> {
		mobileOpen?: boolean;
		items: MenuItem[];
	}

	/*
	 * import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	 * const { pagePath, tenant } = getGlobalTemplateProps();
	 */

	let {
		mobileOpen = $bindable(false),
		/* eslint-disable prefer-const */
		items,
		...props
		/* eslint-enable prefer-const */
	}: MenuProps = $props();

	let mobileMenu: HTMLElement | null = $state(null);
	const { tenant } = getGlobalTemplateProps();
</script>

<nav {...props}>
	<ul class="text-text flex h-full min-h-4 items-stretch gap-4 font-medium leading-6 xl:justify-end xl:gap-7">
		{#each items as { name, href, target }, i (i)}
			<li class="hidden place-items-center xl:grid">
				<span class="group relative flex items-center gap-1.5">
					<a
						role={href ? "link" : "none"}
						{href}
						{target}
						class={[
							"group",
							"uppercase font-bold text-xs/5 md:text-2xs xl:text-xs/5 tracking-wider ",
							"text-caption",
							"relative flex items-center gap-1.5",
							"hover:text-primary transition-colors",
							!href && "cursor-default",
						]}
					>
						{name}
					</a>
				</span>
			</li>
		{/each}
	</ul>
</nav>

<Portal target="body">
	<button
		aria-label="Otevřít mobilní menu"
		type="button"
		class="fixed inset-0 z-40 border-0 border-none bg-black backdrop-blur-sm transition-all duration-500 {mobileOpen
			? 'pointer-events-all opacity-50'
			: 'pointer-events-none opacity-0'}"
		tabindex="-1"
		onclick={(): void => {
			mobileOpen = false;
		}}
	></button>
	<div
		bind:this={mobileMenu}
		class="fixed bottom-0 right-0 top-0 z-50 flex h-full flex-col bg-white p-4 shadow-xl transition-transform duration-500 max-sm:left-0 {mobileOpen
			? 'translate-x-0'
			: 'translate-x-full'}"
	>
		<div class="mb-16 flex items-start justify-between gap-12">
			<a href={getHomepagePath(tenant)} class="flex items-center gap-1">
				<span class="font-semibold -tracking-[0.005em] text-[1.25rem]/6">
					<Media
						alt="🔥"
						width={24}
						height={24}
						source={{ src: flame, type: "image/svg+xml" }}
						class="size-[1em] -translate-y-[0.125em]"
					/>
				</span>
				<span class="text-black -tracking-[0.005em] text-2md/6 font-semibold">Zažehnuto.cz</span>
			</a>

			<button
				class="flex items-center gap-1 font-bold text-black"
				onclick={(): void => {
					mobileOpen = false;
				}}
			>
				Zavřít
				<Icon icon={cross} class="h-4" />
			</button>
		</div>

		<ul class="flex flex-col items-center gap-1 overflow-auto text-lg">
			{#each items as { name, href, target }, i (i)}
				<li class="py-2 xl:py-0">
					<a
						role={href ? "link" : "none"}
						{href}
						{target}
						onclick={(): void => {
							mobileOpen = false;
						}}
						class="text-body17 uppercase font-bold tracking-[0.005em]"
					>
						{name}
					</a>
				</li>
			{/each}
		</ul>

		<div class="mt-6 flex grow flex-col items-center xl:items-start xl:justify-end gap-4">
			<BuyCampfireLink
				variant={ButtonVariant.Secondary}
				onclick={(): void => {
					mobileOpen = false;
				}}
			/>
		</div>
	</div>
</Portal>
